<template>
    <div class="scan-ticket-detail__list-table">
        <div class="table">
            <span class="table__title">{{ getTranslatedText('ticket') }}</span>
            <table>
                <thead>
                    <tr>
                        <th>{{ getTranslatedText('no') }}</th>
                        <th>{{ getTranslatedText('select') }}</th>
                        <th>{{ getTranslatedText('game') }}</th>
                        <th>{{ getTranslatedText('stake') }}</th>
                        <th>{{ getTranslatedText('winnings') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(v, i) in details" :key="i">
                        <td>#{{ i + 1 }}</td>
                        <td>
                            <div class="table-list-number" v-for="(bet, index) in v.bet.bets" :key="index">
                                <span v-if="index > 0">+</span>
                                <div class="table-item-number" v-for="(number, j) in bet" :key="j">
                                    {{ number }}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div :class="`table-item-name ${v.game_name.replace(/\ /g, '-').toLowerCase()}`">
                                {{ getTranslatedText(v.game_name) }}
                            </div>
                        </td>
                        <td>{{ renderPrice(v.wager) }}</td>
                        <td>{{ v.winnings ? renderPrice(v.winnings) : 'N/A' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table">
            <span class="table__title">{{ getTranslatedText('draw') }}</span>
            <div class="table-item-draw" v-for="(value, index) in events" :key="index">
                <div class="table__item">
                    <span class="table__item--text table__item--text-label">{{ getTranslatedText('draw date') }}</span>
                    <span class="table__item--text table__item--text-value"> {{ renderDate(value.draw_date) }} </span>
                </div>
                <div class="table__item">
                    <span class="table__item--text table__item--text-label">{{ getTranslatedText('result') }} </span>
                    <template v-if="value.results && value.results.length > 0">
                        <div class="table-list-number" v-for="(bet, index) in value.results" :key="index">
                            <span v-if="index > 0">+</span>
                            <div class="table-item-number" v-for="(number, j) in bet" :key="j">
                                {{ number }}
                            </div>
                        </div>
                    </template>
                    <span v-else class="table__item--text table__item--text-value">
                        {{ getTranslatedText('pending results') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';

import { formatDateUTC, formatPrice } from '@/utils/utils';

export default {
    mixins: [languageMixins],
    props: {
        details: {
            type: Array,
            default: () => [],
        },
        events: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            height: '',
        };
    },

    methods: {
        renderDate(date) {
            const dateFormat = formatDateUTC(date, 2);

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`;

            return valueDate;
        },

        renderPrice(price) {
            return formatPrice(price);
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/scan/scanDetail.scss';
</style>
